import React from 'react';
import { useHistory } from 'react-router-dom';
import { paintathon, conan } from '../../constants/iconImageConstant';
import { nextbutton, buttonImg } from '../../constants/iconImageConstant';
import { Header } from '../Header/Header';
import { Footer } from '../appFooter/Footer';
// import ReactPlayer from "react-player";

export function EventPage() {
  const history = useHistory();

  const handleNavigate = (path: string) => {
    history.push(path);
  };

  return (
    <>
      <Header />
      <div className='main-container'>
        <main role="main" className="container">
          <div className="col-md-12 mt-3 mb-3 zoom" style={{ position: 'relative' }}>
            <img
              src={paintathon}
              alt="paintathon"
              width="100%"
              onClick={() => handleNavigate('/paintathon')}
              className="clickable-image" loading="lazy"
            />
            <div className="col-md-4 offset-8" style={{ position: 'absolute', top: 0 }}>
              <div style={{ width: '100%', height:'auto', background: '#50584b', borderRadius: '6px', padding: '10px', position: 'relative', right: '30px', top: '20px' }}>
                <div className="embed-responsive embed-responsive-16by9">
                   <video width="100%" height="auto" autoPlay muted>
                     <source src="https://assets.etvbalbharat.com/video/PAINTATHON_PROMO._website.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                  </video> 
                        {/* <ReactPlayer 
                        url="https://assets.etvbalbharat.com/video/PAINTATHON_PROMO._website.mp4" 
                         controls 
                         playing  // AutoPlay enabled
                         muted 
                         width="100%" 
                         height="auto"
                          />  */}

                </div>
              </div>
              <div className="nxtbtns">
                <a href="/paintathon">
                  <img src={nextbutton} alt="btn" width="140"  loading="lazy"/>
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-12 mb-3 zoom" style={{ position: 'relative' }}>
            <img
              src={conan}
              alt="conan"
              width="100%"
              onClick={() => handleNavigate('/canonYears')}
              className="clickable-image"
              loading="lazy"
            />
            <div className="col-md-4 offset-8" style={{ position: 'absolute', top: 0 }}>
              <div style={{ width: '100%', background: '#50584b', borderRadius: '6px', padding: '10px', position: 'relative', right: '30px', top: '20px' }}>
                <div className="embed-responsive embed-responsive-16by9">
                  <video width="100%" height="auto" autoPlay muted>
                  <source src="https://assets.etvbalbharat.com/video/CONAN.mp4" type="video/mp4" /> 
                    <source src="movie.ogg" type="video/ogg" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              <div className="nxtbtns">
                <a href="/canonYears">
                  <img src={buttonImg} alt="btn" width="120"  loading="lazy"/>
                </a>
              </div>
            </div>
          </div>
        </main>
      </div>
      <Footer />
    </>
  );
}












//comment this program.....

// import React from 'react';
// import { useHistory } from 'react-router-dom';
// import { paintathon, conan } from '../../constants/iconImageConstant';
// import { nextbutton, buttonImg } from '../../constants/iconImageConstant';
// import { Header } from '../Header/Header';
// import { Footer } from '../appFooter/Footer';

// export function EventPage() {
//   const history = useHistory();

//   const handleNavigate = (path: string) => {
//     history.push(path);
//   };

//   return (
//     <>
//     <Header/>
//     <div className='main-container'>
//       <main role="main" className="container">
//         <div className="col-md-12 mt-3 mb-3 zoom">
//           <div className="text-center nxtbtns">
//             <a href="/paintathon">
//               <img src={nextbutton} alt="btn" width="140" />
//             </a>
//           </div>
//           <img
//             src={paintathon}
//             alt="paintathon"
//             width="100%"
//             onClick={() => handleNavigate('/paintathon')}
//             className="clickable-image"
//           />
//         </div>
//         <div className="col-md-12 mb-3 zoom" >
//           <div className="text-center nxtbtns">
//             <a href="/canonYears">
//               <img src={buttonImg} alt="btn" width="120" />
//             </a>
//           </div>
//           <a href="/canonYears">
//             <img
//               src={conan}
//               alt="conan"
//               width="100%"
//               onClick={() => handleNavigate('/canonYears')}
//               className="clickable-image"
//             />
//           </a>
//         </div>
//       </main>
     
//     </div>
//     <Footer />
//     </>
//   );
// }



